import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import { Zoom } from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/styles.css";

export default function Gallery({images, listing: {name}, organization: {name: orgName}}) {
  const [index, setIndex] = useState(-1);

  const openLightbox = (index=0) => (e) => {
    e.preventDefault();
    setIndex(index);
  };
  const closeLightbox = (_e) => setIndex(-1);

  return (
    <div className="gallery">
      <div className="images">
        {images.map((image, index) => (
          <img
            src={image.medium_src}
            key={image.medium_src}
            onClick={openLightbox(index)}
            alt={`My Right Horse: ${name} ${orgName} photo ${index + 1}`}
          />
        ))}
      </div>
      <div className="centered-buttons">
        <button type="button" className="btn btn-primary view-more" onClick={openLightbox()}>
          View photos
        </button>
      </div>
      <Lightbox
        slides={images}
        index={index}
        open={index >= 0}
        close={closeLightbox}
        controller={{closeOnBackdropClick: true}}
        plugins={[Zoom]}
      />
    </div>
  );
}
